
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppTable, AppButton, AppSelect, AppFormRow } from '@/components';
import { ROUTE_NAME_COLLECTION } from '@/modules/collection/router';
import { useCollectionList } from '@/modules/collection/model/list';
import { CollectionSelectOptions, CollectionType } from '@/modules/collection/types';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: 'CollectionGaleryList',
    components: { AppTable, AppButton, AppSelect, AppFormRow, AppCard },
    setup() {
        const { list, total, fetchList, actions, selectedType, selectableTypeOptions } = useCollectionList(
            CollectionType.Theme
        );

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'Id', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Html, label: 'Color', htmlHandler: (row: any) => renderColor(row.coverColor) },
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: CollectionSelectOptions.Type },
                {
                    type: TableColumnType.Option,
                    label: 'Status',
                    key: 'status',
                    options: CollectionSelectOptions.Status
                },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-gift',
                        theme: 'info',
                        tooltip: 'View levels',
                        to: { name: ROUTE_NAME_COLLECTION.ITEM.INDEX(row.type), params: { collectionId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_COLLECTION.EDIT(row.type), params: { collectionId: row.id } }
                    }),
                    canShow: (row: any) => row.canEdit,
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_COLLECTION.DETAIL(row.type), params: { collectionId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-language',
                        theme: 'info',
                        tooltip: 'Translate',
                        to: { name: ROUTE_NAME_COLLECTION.TRANSLATE(row.type), params: { collectionId: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-play',
                        theme: 'success',
                        tooltip: 'Publish',
                        onClick: () => actions.publish(row.id)
                    }),
                    canShow: (row: any) => row.canPublish,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-stop',
                        theme: 'warning',
                        tooltip: 'Unpublish',
                        onClick: () => actions.unpublish(row.id)
                    }),
                    canShow: (row: any) => row.canUnpublish,
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, fetchList, selectedType, selectableTypeOptions, ROUTE_NAME_COLLECTION };
    }
});

function renderColor(color: string) {
    return color
        ? `<div style="float: left; margin-right: 20px; width: 20px; height: 20px; background-color:#${color}" ></div>${color}`
        : '';
}
